<template>
    <PageContainer>
        <PageHeader>
            {{ $t('user.index.page_title') }}

            <template #right>
                <CreateButton class="btn-sm" href="/users/create" />
            </template>
        </PageHeader>

        <base-table>
            <template #thead>
                <th>{{ $t('user.name') }}</th>
                <th>{{ $t('user.email') }}</th>
                <th>{{ $t('user.role') }}</th>
                <th>{{ $t('user.created_at') }}</th>
            </template>
            <tr v-for="user in pagination.data" class="align-middle">
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.role }}</td>
                <td>{{ user.created_at }}</td>
                <td class="text-end">
                    <EditButton class="btn-sm" :href="'/users/'+ user.id + '/edit'" />
                </td>
            </tr>
        </base-table>

        <Pagination
            :pagination="pagination.pagination"
        />
    </PageContainer>
</template>

<script setup lang="ts">
import BaseTable from "@/components/elements/BaseTable.vue";
import Pagination from "@/components/elements/Pagination.vue";
import type {PaginatedResponse, UserInterface} from "@/components/helpers/Interfaces.ts";
import {usePagination} from "@/Composable/usePagination.ts";
import PageHeader from "@/components/elements/PageHeader.vue";
import CreateButton from "@/components/buttons/CreateButton.vue";
import EditButton from "@/components/buttons/EditButton.vue";
import PageContainer from "@/components/elements/PageContainer.vue";

const { users } = defineProps<{
    users: PaginatedResponse<UserInterface>
}>()

const pagination = usePagination<UserInterface>(users)
</script>

<style scoped>

</style>
